import { SequencesMinigame } from '@phaser/minigames/sequences';
import { DEPTH } from '@phaser/data/depth';
import { Game } from '@phaser/scenes/Game';

export class SequenceCell {
  public get container() {
    return this._container;
  }

  private _activeBackground: Phaser.GameObjects.Rectangle;
  private _background: Phaser.GameObjects.Rectangle;
  private _container: Phaser.GameObjects.Container;
  private _text: Phaser.GameObjects.Text;
  private _scene: Game = Game.current;
  private _isSelectable = false;
  private _isActive = false;

  constructor(
    private sequence: SequencesMinigame,
    private x: number,
    private y: number,
    private size: number,
    private coords: { x: number; y: number }
  ) {
    this._placeCell();
    this._registerEvents();
  }

  public markSelectable(selectable = false) {
    this._isSelectable = selectable;
    this._background.setAlpha(selectable ? 0.1 : 0);
  }

  public markActive(active = false) {
    this._isActive = active;
    this._activeBackground.setStrokeStyle(active ? 2 : 0, 0x00DDFF);
  }

  public setText(text: string) {
    this._text.setText(text);
  }

  public destroy() {
    this._container.destroy();
  }

  private _placeCell() {
    this._container = this._scene.add.container(this.x, this.y).setDepth(DEPTH.MINIGAME);

    this._background = this._scene.add.rectangle(0, 0, this.size, this.size, 0xFFFFFF)
      .setInteractive();
    this._activeBackground = this._scene.add.rectangle(0, 0, this.size - 8, this.size - 8);

    this._text = this._scene.add.text(0, 0, '1A', {
      fontFamily: 'Ascentian',
      fontSize: '36px',
      resolution: 2,
    }).setOrigin(0.5).setScale(0.5).setAlpha(0);

    this._scene.add.tween({
      duration: Math.random() * 200 + 200,
      targets: this._text,
      ease: 'Power2',
      scale: 1,
      alpha: 1,
    });

    this._container.add([this._background, this._activeBackground, this._text]);
  }

  private _registerEvents() {
    this._background.on('pointerup', () => {
      if (!this._isSelectable || this._isActive) return;

      this.markActive(true);
      this.sequence.activate(this.coords);
    });
  }
}